import { Capacitor } from "@capacitor/core";
import React from "react";
import { useMediaQuery } from "react-responsive";

const LoadingScreen = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
  const isWeb = Capacitor.getPlatform() === "web"

  return isWeb ? (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${isMobile ? "/splash-bg.png" : "/lg-splash.png"})`,
      }}
    >
      <div className="w-fit rounded-[1rem] bg-white/10 px-[2rem] py-[1rem]">
        <img
          id="image"
          src="/logo-image.svg"
          alt="logo"
          className="w-[200px] md:w-[300px]"
        />
      </div>

      <h1 className="text-center text-[28px] leading-[1.1] font-bold text-white lg:text-3xl">
        Your Digital Services Hub
      </h1>
    </div>
  ) : <div className="flex h-screen w-full items-center justify-center">
    <img
      id="image"
      src="/logo.svg"
      alt="logo"
      className="w-[100px] md:w-[200px]"
    />
  </div>;
};

export default LoadingScreen;
